import SampleReportView from "@/components/samples/SampleReportView";
import { PIVOT_REPORT } from "@/data/sample-reports";

const PivotSample = () => <SampleReportView report={PIVOT_REPORT} />;

export default PivotSample;
